import { useState } from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";

import { ListItemText } from "@material-ui/core";

import { useEffect } from "react";

const methods = ["Cartão de Credito", "Boleto Bancário", "Dinheiro", "PIX"];

export default function PaymentMethodsMultipleSelect({ label, handleChange, payments }) {
  const [paymentMethod, setPaymentMethod] = useState([]);

  useEffect(() => {
    setPaymentMethod([...payments]);
  }, [payments]);

  const handleChangeSelect = (event) => {
    const {
      target: { value },
    } = event;
    setPaymentMethod(() => value);
    handleChange({ target: { name: "payments", value: value } });
  };

  return (
    <FormControl sx={{ mt: -0.5, width: "100%" }}>
      <InputLabel id={`demo-multiple-chip-${label}`}>{label}</InputLabel>
      <Select
        labelId={`demo-multiple-chip-${label}`}
        id="demo-multiple-name"
        multiple
        value={paymentMethod}
        onChange={handleChangeSelect}
        name="payments"
        input={<OutlinedInput label={label} />}
        renderValue={(selected) => selected.join(", ")}
      >
        {methods.map((name) => (
          <MenuItem key={name} value={name}>
            <Checkbox checked={paymentMethod.includes(name)} />
            <ListItemText primary={name} />
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
